export default __webpack_public_path__ + "media/siteware_admin/favicon-192-c16de35f5eafb83c5200e890743d3d1b.png";